module.exports = __webpack_public_path__ + "static/media/deno.4b150ace.svg";